<template>
  <div class="record-modal">
    <van-overlay :show="visible" :lock-scroll="false" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="card">
          <div class="table">
            <div class="thead">
              <div class="th name">奖品</div>
              <div class="th date">领取日期</div>
            </div>
            <div class="tbody">
              <div class="tr" v-for="(item, idx) in list" :key="idx">
                <div class="top">
                  <div class="td name">{{ item.equityName }}</div>
                  <div class="td date">{{ item.createTime }}</div>
                </div>
                <!-- equityType权益类型：1-微信立减金 2-京东e卡 3-商城积分 4-手机话费充值卡 -->
                <div
                  v-if="item.equityType === 4 && item.redeemCode"
                  class="td extra"
                >
                  <span class="label">充值链接：</span>
                  <span class="text">{{ item.redeemCode }}</span>
                  <van-button
                    class="copy-btn"
                    type="primary"
                    size="small"
                    @click="copy(item.redeemCode)"
                  >
                    复制
                  </van-button>
                </div>
                <div v-if="item.equityType === 2" class="td extra">
                  <span class="label">卡号：</span>
                  <span class="text">{{ item.cardNo }}</span>
                  <van-button
                    class="copy-btn"
                    type="primary"
                    size="small"
                    @click="copy(item.cardNo)"
                  >
                    复制
                  </van-button>
                </div>
                <div v-if="item.equityType === 2" class="td extra">
                  <span class="label">卡密：</span>
                  <span class="text">{{ item.cardPwd }}</span>
                  <van-button
                    class="copy-btn"
                    type="primary"
                    size="small"
                    @click="copy(item.cardPwd)"
                  >
                    复制
                  </van-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="close-btn" @click="onClose">
          <span class="x">×</span>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getRecordPages } from '@/api/xibPromotionGift'
import useClipboard from 'vue-clipboard3'
const { toClipboard } = useClipboard()
export default {
  name: 'RecordModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: []
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.loadData()
        }
      },
      immediate: false
    }
  },
  methods: {
    async loadData() {
      const { data } = await getRecordPages({
        pageNum: 1,
        pageSize: 100,
        param: {}
      })
      this.list = data.records
    },
    onClose() {
      this.$emit('confirm')
    },
    async copy(text) {
      try {
        await toClipboard(text)
        console.log('Copied to clipboard')
        this.$toast.success('复制成功!')
      } catch (e) {
        console.error(e)
        this.$toast.fail('复制失败!')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.record-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    box-sizing: border-box;
  }
  .card {
    width: 320px;
    max-height: 430px;
    background: url('~@/assets/imgs/promotionGift/recordBg.png') no-repeat;
    background-size: 100% auto;
    border-radius: 18px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    padding: 0 10px 18px;
    box-sizing: border-box;
    position: relative;
    .table {
      margin-top: 80px;
      background: #ffffff;
      border-radius: 20px;
      padding: 12px 10px 10px;
      .thead {
        display: grid;
        grid-template-columns: 1fr 1fr;
        background: #f4eeff;
        border-radius: 7px;
        color: #9256f9;
        font-weight: 600;
        font-size: 12px;
        padding: 0px 35px;
        .th {
          padding: 8px 10px;
        }
        .name {
          text-align: left;
        }
        .date {
          text-align: right;
        }
      }
      .tbody {
        max-height: 300px;
        box-sizing: border-box;
        overflow-y: auto;
        .tr {
          border-bottom: 1px solid #e6e6e6;
          padding: 10px 0;
          &:last-child {
            border-bottom: none;
          }
          .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .td {
            padding: 0 6px;
            font-size: 14px;
          }
          .name {
            padding-top: 2px;
            color: #000000;
          }
          .date {
            text-align: right;
            color: #999999;
          }
          .extra {
            display: flex;
            align-items: center;
            margin-top: 6px;
            .label {
              color: #9358f9;
              font-size: 12px;
              margin-right: 4px;
            }
            .text {
              flex: 1;
              font-size: 12px;
              color: #9358f9;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-right: 8px;
            }
            .copy-btn {
              width: 48px;
              height: 24px;
              line-height: 24px;
              border-radius: 5px;
              font-size: 12px;
              background: #9358f9;
              border: none;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .close-btn {
    margin-top: 16px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    .x {
      font-size: 20px;
      color: #fff;
      line-height: 30px;
      display: block;
    }
  }
}
</style>
